var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form-item-wrapper', {
    attrs: {
      "designer": _vm.designer,
      "field": _vm.field,
      "rules": _vm.rules,
      "design-state": _vm.designState,
      "parent-widget": _vm.parentWidget,
      "parent-list": _vm.parentList,
      "index-of-parent-list": _vm.indexOfParentList,
      "sub-form-row-index": _vm.subFormRowIndex,
      "sub-form-col-index": _vm.subFormColIndex,
      "sub-form-row-id": _vm.subFormRowId
    }
  }, [_c('vue-editor', {
    ref: "fieldEditor",
    class: {
      'readonly-mode-rich-editor': _vm.isReadMode
    },
    attrs: {
      "editor-toolbar": _vm.customToolbar,
      "disabled": _vm.field.options.disabled || _vm.isReadMode,
      "placeholder": _vm.field.options.placeholder
    },
    on: {
      "text-change": _vm.handleRichEditorChangeEvent,
      "focus": _vm.handleRichEditorFocusEvent,
      "blur": _vm.handleRichEditorBlurEvent
    },
    model: {
      value: (_vm.fieldModel),
      callback: function($$v) {
        _vm.fieldModel = $$v
      },
      expression: "fieldModel"
    }
  })], 1)
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-184cfc9e","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form-designer/form-widget/field-widget/rich-editor-widget.vue
// module id = null
// module chunks = 